import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../../services/ViewService";
import { Attachment, AttachmentActionsContext, AttachmentType, buildAttachmentIconName, IAttachmentActions } from "../../../../../../entities/Subentities";
import EntityName from "../../EntityName";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { EntityType } from '../../../../../../entities/common';

type Props = IListViewFieldColumn<Attachment> & RouteComponentProps<{}>

const Title = (props: Props) => {

    const { entity, isTimelineView, className, location } = props;
    const query = new URLSearchParams(location.search);
    query.set(EntityType.Attachment, entity.id);

    const context = React.useContext(AttachmentActionsContext)
    return <EntityName
        name={entity.attributes.Name}
        isTimelineView={isTimelineView}
        url={getAttachmentUrl(entity, context?.actions)}
        openNewPage={true}
        className={className}
        iconName={buildAttachmentIconName(entity.attributes.Type)}
        warnings={entity.warnings}
    />;
}

const inlineFileTypes = [AttachmentType.PDF, AttachmentType.Image];

export const getAttachmentUrl = (entity: Attachment, actions?: IAttachmentActions | null) => entity.attributes.Type === AttachmentType.LinkedFile
    ? entity.attributes.Url
    : actions?.getFileLink(entity, inlineFileTypes.includes(entity.attributes.Type));

export default withRouter(Title);